import React, { useState } from "react";
import "./bgImage.css";
import bg from "../assets/pixBg.jpeg";
import about from "../assets/about.png";
import skills from "../assets/skills.png";
import socrates from "../assets/socrates.png";
import bookly from "../assets/bookly.png";
import cancerDect from "../assets/cancerDect.jpeg";
import emoter from "../assets/emoter.png";

import gmailIcon from "../assets/mail.png"; 
import githubIcon from "../assets/github.png";
import linkedinIcon from "../assets/linkedin.png";


const BgImage = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);

  const projects = [
    { image: socrates, description: "SocratesAI:An AI-driven chat interface using Google’s Gemini 1.5 Pro model, focused on teaching data structures and algorithms through adaptive questioning. ",
      link: "https://socrates-ai-orcin.vercel.app/chat"
     },
    { image: bookly, description: "Bookly: Smart Chrome extension that simplifies bookmark management.It categorizes bookmarks into custom groups based on content, adds concise summaries for each saved link.",
      link: "https://github.com/Amala02/bookmarks"
     },
    { image: cancerDect, description: "CancerDect: A cancer-detection app that shows probability of a cancerous cell with the use of YoLoV8 model.",
      link: "https://cancer-dect-02.streamlit.app/"
     },
    { image: emoter, description: "Emoter: NLP model to detect emotions based off your texts and recommend songs and books of the same.", link:"https://github.com/Amala02/emoter_react" },
  ];

  const handleButtonClick = (button) => {
      setActiveButton(activeButton===button? null : button); // Deselect the button if clicked again
     
  };

  const handleNextProject = () => {
    setCurrentProjectIndex((prevIndex) => (prevIndex + 1) % projects.length);
  };

  const handlePreviousProject = () => {
    setCurrentProjectIndex((prevIndex) =>
      (prevIndex - 1 + projects.length) % projects.length
    );
  };

  return (
    <div className="image-container">
      <img src={bg} alt="Background" className="centered-image" />
      <div className="title-overlay">Amala Shwetah</div>
      <div className="button-container">
        {[">About", ">Skills", ">Projects", ">Connect"].map((button) => (
          <button
            key={button}
            className={`button-option ${
              activeButton === null || activeButton === button ? "inactive" : "highlight"
            }`}
            onClick={() => handleButtonClick(button)}
          >
            {button}
          </button>
        ))}
        <div class="credit">Icons, Bg Image:freepik </div>
      </div>
      
      <div className="content">
        {activeButton === ">About" && <div><img src={about} alt="About" className="about-image"/> </div>}
        {activeButton === ">Skills" && <div><img src={skills} alt="Skills" className="about-image"/></div>}
        {activeButton === ">Projects" && ( <div className="carousel">
        <div className="project-display">
          
          <a href={projects[currentProjectIndex].link} target="_blank" rel="noopener noreferrer">
            <img
              src={projects[currentProjectIndex].image}
              alt={`Project ${currentProjectIndex + 1}`}
              className="project-image"
            />
          </a>
          <p className="project-description">
            {projects[currentProjectIndex].description}
          </p>
        </div>
        <div className="carousel-buttons">
          <button onClick={handlePreviousProject}>Previous</button>
          <button onClick={handleNextProject}>Next</button>
        </div>
        <div id="note">ps: Click on the images to explore</div>
      </div>)}
        {activeButton === ">Connect" && (
          <>Let's Connect!
          <div className="social-icons">
            
            <a href="mailto:amalashwetah221@gmail.com" target="_blank" rel="noopener noreferrer">
            <img src={gmailIcon} alt="Gmail" className="icon-image" />
            </a>
            <a href="https://github.com/amala02" target="_blank" rel="noopener noreferrer">
            <img src={githubIcon} alt="GitHub" className="icon-image" />
            </a>
            <a href="https://www.linkedin.com/in/Amala-Shwetah-Louis/" target="_blank" rel="noopener noreferrer">
            <img src={linkedinIcon} alt="LinkedIn" className="icon-image" />
            </a>
          </div>
          </>
        )}
     </div>
    </div>
  );
};

export default BgImage;
